<template>
    <section v-if="hasPermissions(['Daily-Assignment Read',  'Daily-Assignment Write', 'Daily-Assignment Daily-Assignment-Upload'])" class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1">
            {{ title_page }}
        </h1>
        <div class="view__description">
            <p class="view__description__text">
                This is a <span @click="replacingRoomTask()">list</span> of the Daily Assignments. Clicking the Detail icon allows you to modify the specifics of the Assignment. Clicking the Description link allows you to add and remove Rooms. To add a new Assignment, click "Add Daily Assignment" and fill in the required fields, then click Save.
            </p>
        </div>

        <div class="bar-container">
            <div class="bar-container__search-bar">
                <div class="input-field my-0" v-if="hasPermissions(['Daily-Assignment Read'])">
                    <i class="material-icons prefix iconInput">search</i>
                    <input id="icon_prefix" type="text" class="validate inputSearch" placeholder="Search" v-on:input="debounceInput($event.target.value)">
                </div>
            </div>
            <div class="bar-container__options">
                <UploadOptions
                    :ref="'file_excel'"
                    :empty_format_data="empty_format_data"
                    :excel_file_headers="excel_file_headers"
                    :file_name="'Assigments_template_file'"
                    @data="upload($event)"
                    v-if="hasPermissions(['Daily-Assignment Daily-Assignment-Upload'])"
                />
                <a v-if="hasPermissions(['Daily-Assignment Write'])" class="modal__buttons__item btn-width-3" href="/assignment-mass-edit" v-html="'Mass Edit'"/>
                <button v-if="hasPermissions(['Daily-Assignment Write'])" class="modal__buttons__item w-auto px-3" v-html="'Mass Delete'" :class="{'disabled button__disabled' : !selected}" :disabled="!selected" @click="massive_modal_delete()"/>
            </div>
            <div v-if="hasPermissions(['Daily-Assignment Write'])" class="bar-container__cta">
                <span class="button__modal text-right">
                    <a href="#" @click="form_modal()" class="d-inline-md-block">
                        {{ add_btn }}
                        <i class="prefix ml-1">
                            <img src="/assets/img/svg/add.svg" alt="date" style="width: 15px">
                        </i>
                    </a>
                </span>
            </div>
        </div>

        <DailyAssignmentsAdvancedSearch
            class="mt-5"
            ref="advanced_search"
            :use_parent="false"
            :table_headers="table_headers"
            :checkeable="true"
            :historiable="false"
            :updateable="true"
            :rest_api="rest_api"
            :rest_api_pagination="rest_api_pagination"
            @emitLinkAction="emitLinkAction($event)"
            @passInitialData="getInitialData($event)"
            @modal_update="modal_update($event)"
            @paginateMoreRecordsParent="paginateMoreRecords($event)"
            @fetchMainListParent="fetchMainList($event)"
            :search="search"
            @updateSelectedState="updateSelectedState"
        />

        <DeletionModal 
            :single_object="single_object" 
            :global_index="global_index" 
            @objectDeletion="object_deletion($event)"
        />

        <DeletionMassiveModal
            @objectDeletion="massive_local_emition($event)"
        />

        <FormModal 
            :title="'New Daily Assigment'"
            :breadcrumb="breadcrumb"
            :rest_api="rest_api"
            :notyf="notyf"
            :array_options="array_options"
            @unshiftObject="unshift_object($event)"
        />

        <UpdateModal 
            :title="'Daily Assigment Update'"
            :breadcrumb="breadcrumb"
            :rest_api="rest_api"
            :notyf="notyf"
            :single_object="single_object"
            :global_index="global_index"
            :array_options="array_options"
            @spliceObject="splice_object($event)"
            ref="update_modal"
        />

        <WaitingModal/>

        <HistoryMovementModal
            :notyf="notyf"
            :link_message="`<a href='#'>Back to History</a>`"
            :rest_api="rest_api"
            :history_item="history_item"
            :breadcrumb="breadcrumb"
            :link_event="true"
            @linkEventReceiver="linkEmitEmisor()"
        />

        <HistoryModal
            :link_message="`<a href='#'>View room movement history</a>`"
            :histories="histories"
            :title="history_title"
            :breadcrumb="breadcrumb"
            :link_event="true"
            @linkEventReceiver="linkEmitReceptor()"
        />

        <UploadSummary
            :breadcrumb="breadcrumb"
            :summary="summary"
            :excel_file_headers="excel_file_headers"
            :excel_data="excel_data"
            :file_name="'assignments_falied_template_file'"
        />

        <HelperModal :helps="helps"/>

    </section>
    <div v-else>
        <UnauthorizedComponent :breadcrumb="breadcrumb"/>
    </div>
</template>

<script>

import Breadcrumb               from    '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal             from    '@/components/WaitingModal'
import Resources                from    './resources'
import FormResources            from    './form_resources'
import FormModal                from    './FormModal'
import UpdateModal              from    './UpdateModal'
import DeletionModal            from    '@/components/DeletionModal'
import HelperModal              from    '@/components/HelperModal'
import DeletionMassiveModal     from    '@/components/DeletionMassiveModal'
import HistoryModal             from    '@/components/HistoryModal'
import UploadOptions            from    '@/components/UploadOptions'
import HistoryMovementModal     from    './HistoryMovementModal'
import UploadSummary            from    '@/components/UploadSummary'
import UnauthorizedComponent from   '@/components/UnauthorizedComponent'
import _ from 'lodash'
import 'vuetify/dist/vuetify.min.css'

import { Notyf }            from    'notyf';
import 'notyf/notyf.min.css'; // for React and Vue
import DailyAssignmentsAdvancedSearch from './AdvancedSearch/DailyAssignmentsAdvancedSearch.vue'
const notyf = new Notyf({
    duration: 8000,
});
export default {

    name: 'DailyAssignment',

    components: {
    Breadcrumb,
    WaitingModal,
    DeletionModal,
    DeletionMassiveModal,
    FormModal,
    UpdateModal,
    HistoryModal,
    UploadOptions,
    HistoryMovementModal,
    UploadSummary,
    UnauthorizedComponent,
    DailyAssignmentsAdvancedSearch,
    HelperModal
},

    data() {
        return {
            notyf,
            child_href:             '/assignment-daily-assignments/',
            title_page:             'Daily Assignments',
            user:                   this.get_user(),
            rest_api:               `daily_assignments`,
            table_headers:          Resources.table_headers,
            breadcrumb:             Resources.breadcrumb,
            form_format_main_search:       FormResources.form_format_main_search,
            form_data_main_search:       FormResources.form_data_main_search,
            add_btn:                'Add Daily assignment',
            single_select:          false,
            table_selection:        [],
            search:                 '',
            global_index:           0,
            single_object:          {},
            daily_assignments:      [],
            
            array_options: {
                associate_id: [],
                shift_id: [],
                group_id: [],
                cost_center_department_id: [],
                supervisor_associate_id: [],
            },

            histories:              [],
            history_title:          '',
            select_ids:             [],
            excel_file_headers:     Resources.excel_file_headers,
            empty_format_data:      Resources.empty_format_data,
            excel_fields_required:  Resources.excel_fields_required,
            supervisors:            [],
            history_item:           {},
            summary:                [],
            excel_data:             [],
            rest_api_pagination:    'daily_assignments_pagination',
            selected: false,
            helps:                  Resources.helps_main_screen
        }
    },

    methods: {
        async updateSelectedState(state)
        {
            this.selected = state
        },
        async replacingRoomTask()
        {
            await this.get('replacing_room_tasks')
        },

        linkEmitReceptor()
        {
            window.$('#static-history').modal('hide')

            setTimeout(() => {
                window.$('#static-history-movement').modal('show')
            }, 500)
        },

        linkEmitEmisor()
        {
            window.$('#static-history-movement').modal('hide')

            setTimeout(() => {
                window.$('#static-history').modal('show')
            }, 500)
        },

        unshift_object()
        {
            this.$refs.advanced_search.resetList()
        },

        splice_object()
        {
            this.$refs.advanced_search.resetList()
        },

        form_modal()
        {
            if(!this.user.has_facility)
            {
                notyf.error('There is not exists a facility yet')
                return false
            }
            window.$('#static').modal('show')
        },

        modal_deletion(index)
        {
            this.global_index  = index
            this.single_object = this.daily_assignments[index]
            window.$('#static-deletion').modal('show')
        },

        modal_update(index)
        {
            this.global_index  = index
            this.single_object = this.$refs.advanced_search.assignments[index]
            const days = this.array_options.day_id.filter(day => this.single_object[day.id]).map(day => day.id);

            this.single_object = {...this.single_object, new_assignment_room_images: [], day_id: days}
            this.$refs.update_modal.initiate(this.single_object.id)

            window.$('#static-update').modal('show')
        },

        fill_data(data)
        {
            this.daily_assignments = data.daily_assignments

            !this.has_role('Employee')
            {
                this.supervisors = data.supervisors
                this.array_options = {
                    associate_id: data.associates,
                    shift_id: data.shifts,
                    group_id: data.groups,
                    day_id: data.days,
                    cost_center_department_id: data.cost_center_departments,
                    supervisor_associate_id: data.supervisors,
                    new_assignment_room_images: 'image/jpeg, image/png, image/jpg, image/webp'
                
                }
            }
        },

        trashing(index)
        {
            this.daily_assignments.splice(index, 1)
        },

        async history(id, title)
        {
            if(title === undefined)
            {
                title = id.title
                id = id.id
            }
            const http_request = {
                id,
                history_request: true,
            }

            this.history_item = {
                id,
                title,
            }
            this.loader(true)

            const response = await this.get(`${this.rest_api}/${JSON.stringify(http_request)}`)

            this.loader()

            if(response.status)
            {
                this.history_title = title
                this.histories = response.data.histories

                if(!this.histories.length)
                {
                    this.notyf.error('Empty History')
                }

                setTimeout(()=>{
                    window.$('#static-history').modal('show')
                }, 500)
            }
            else
            {
                this.error_handling(response)
            }
        },

        massive_modal_delete()
        {
            let selection = this.$refs.advanced_search.returnedAsssignmentsToParent()

            selection.checked_items = selection.checked_items.map(item => item.id)
            selection.unchecked_items = selection.unchecked_items.map(item => item.id)

            this.select_ids = selection

            if(this.select_ids.checked_items.length )
            {
                window.$('#static-deletion-massive').modal('show')
            }
        },

        async massive_local_emition()
        {
            let sendingMassive = await this.massive_delete(this.select_ids, null, true)

            if(sendingMassive)
            {
                this.$refs.advanced_search.resetList()
            }
        },

        async upload(data)
        {
            const send_data = [];
            this.excel_data = []

            for ( const value of data ) {
                const entity = {}

                for (const prop in this.excel_file_headers) {
                    entity[this.excel_file_headers[prop]] = this.parse_boolean(value[prop])
                }

                this.excel_data.push({... entity})

                const supervisor = this.array_options.supervisor_associate_id.find(item => entity.supervisor_associate_id && item.name && item.name.toLowerCase() == entity.supervisor_associate_id.toLowerCase())
                entity.supervisor_associate_id = supervisor ? supervisor.id : (entity.supervisor_associate_id) ? 'not-found' : null

                const associate = this.array_options.associate_id.find(item => entity.associate_id && item.associate_name && item.associate_name.toLowerCase() == entity.associate_id.toLowerCase())
                entity.associate_id = associate ? associate.id : (entity.associate_id) ? 'not-found' : null

                const group = this.array_options.group_id.find(item => item.name == entity.group_id)
                entity.group_id = group ? group.id : (entity.group_id) ? 'not-found' : null

                const shift = this.array_options.shift_id.find(item => item.name == entity.shift_id)
                entity.shift_id = shift ? shift.id : (entity.shift_id) ? 'not-found' : null

                const department = this.array_options.cost_center_department_id.find(item => item.name == entity.cost_center_department_id)
                entity.cost_center_department_id = department ? department.id : (entity.cost_center_department_id) ? 'not-found' : null

                send_data.push(entity)

            }

            
            this.loader(true)
            const response = await this.post(`${this.rest_api}/massive`, { daily_assignments: send_data })
            this.loader()

            if(response.status)
            {
                notyf.success('Success!')
                this.summary = response.data.summary
                window.$('#upload-summary').modal('show')

                this.$refs.advanced_search.resetList()
            }
            else
            {
                this.error_handling(response)
            }
            
            this.$refs.file_excel.clear_data()
        },

        getInitialData(data)
        {
            this.supervisors = data.supervisors
            this.array_options = {
                associate_id: data.associates,
                shift_id: data.shifts,
                group_id: data.groups,
                day_id: data.days,
                cost_center_department_id: data.cost_center_departments,
                supervisor_associate_id: data.supervisors,
                new_assignment_room_images: 'image/jpeg, image/png, image/jpg, image/webp'
            }
        },

        debounceInput:  _.debounce(function (e)  {
            this.search = e
        },800),

    },

    async mounted()
    {

    },

}
</script>